import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../../primitives/ids.js";
import { DeliveryProjectIdSchema } from "./entities.js";
import { WebsiteDeliveryEstimateV1Schema } from "./estimate.js";
import { assertPublicWebsiteDeliveryRefOnly, BusinessGraphPublicWebsiteDeliveryRefV1Schema, } from "./isolation.js";
export const WebsiteDeliveryProposalV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.website-delivery-proposal.v1.0"),
    proposalId: z.string().regex(/^wdpr_[a-zA-Z0-9_-]+$/),
    proposalVersion: z.number().int().positive(),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    deliveryProjectId: DeliveryProjectIdSchema,
    estimate: WebsiteDeliveryEstimateV1Schema,
    publicBusinessTruthRef: BusinessGraphPublicWebsiteDeliveryRefV1Schema,
    governanceStatus: z.enum(["DRAFT", "ISSUED", "WITHDRAWN"]),
    issuedAt: z.string().datetime().optional(),
    createdAt: z.string().datetime(),
})
    .strict();
export function buildGovernedWebsiteDeliveryProposal(input) {
    if (input.estimate.status === "SUPERSEDED") {
        throw new Error("estimate_superseded");
    }
    if (input.estimate.agencyId !== input.agencyId) {
        throw new Error("estimate_tenant_mismatch");
    }
    const safeRef = assertPublicWebsiteDeliveryRefOnly(input.publicBusinessTruthRef);
    if (safeRef.agencyId !== input.agencyId || safeRef.projectId !== input.projectId) {
        throw new Error("public_ref_tenant_mismatch");
    }
    const ts = input.now ?? new Date().toISOString();
    return WebsiteDeliveryProposalV1Schema.parse({
        schemaVersion: "clientops.website-delivery-proposal.v1.0",
        proposalId: input.proposalId,
        proposalVersion: input.proposalVersion,
        agencyId: input.agencyId,
        projectId: input.projectId,
        deliveryProjectId: input.deliveryProjectId,
        estimate: input.estimate,
        publicBusinessTruthRef: safeRef,
        governanceStatus: "DRAFT",
        createdAt: ts,
    });
}
export function issueWebsiteDeliveryProposal(proposal, now) {
    if (proposal.governanceStatus !== "DRAFT") {
        throw new Error("proposal_not_draft");
    }
    const ts = now ?? new Date().toISOString();
    return WebsiteDeliveryProposalV1Schema.parse({
        ...proposal,
        governanceStatus: "ISSUED",
        issuedAt: ts,
    });
}
//# sourceMappingURL=proposal.js.map